import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdf34444"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-select-container" }
const _hoisted_2 = { href: "javascript:;" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
      overlay: _withCtx(() => [
        (_ctx.options && _ctx.options.length)
          ? (_openBlock(), _createBlock(_component_a_menu, {
              key: 0,
              onClick: _ctx.onItemSelect,
              selectedKeys: _ctx.current,
              "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.current) = $event)),
              style: {"max-height":"240px","overflow":"auto"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: item.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_2, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["onClick", "selectedKeys"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          allowClear: "",
          size: _ctx.size,
          value: _ctx.value,
          placeholder: _ctx.placeholder,
          onChange: _ctx.onSearchTextChange,
          onFocus: _ctx.onSearchTextChange
        }, null, 8, ["size", "value", "placeholder", "onChange", "onFocus"])
      ]),
      _: 1
    })
  ]))
}